import React from 'react';
import PropTypes from 'prop-types';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { Body4 } from '../../../../../atomic/text/Text';
import { colors } from '../../../../../../colorVars';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { observer } from 'mobx-react-lite';
import { translateOptionSymbol } from '../../../../../../stores/websocketStore/utils/mungingUtils/translateOptionSymbol';
import { estDateStringToTimeAndDateEST } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/estDateStringToTimeAndDateEST';

export const OpenPositionRow = observer(({ positionId, department, odd }) => {
  const { tradePlanStore } = useWebsocketStore();
  const position = tradePlanStore.positions[department][positionId] ?? null;
  if (!position) return null;
  const percentPnl = ApplyRounding(
    ((position.uPnlAtBidAsk +
      position.realizedPnl +
      position.costBasisForEntryTrade) /
      position.costBasisForEntryTrade -
      1) *
      100,
    2
  );
  return (
    <>
      <tr
        style={{
          backgroundColor: odd ? colors.grey : colors.black,
        }}
      >
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {position.type === 'option'
                ? translateOptionSymbol(position.symbol)
                : position.symbol}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {position.sideEnum}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {position.quantity}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {ApplyRounding(position.avg_fill_price, 2)}
            </Body4>
          </td>

          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {isNaN(ApplyRounding(position.bid, 2))
                ? '-'
                : ApplyRounding(position.bid, 2)}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {isNaN(ApplyRounding(position.ask, 2))
                ? '-'
                : ApplyRounding(position.ask, 2)}
            </Body4>
          </td>

          <td>
            <Body4
              fontWeight={600}
              color={
                position.uPnlAtBidAsk === 0
                  ? colors.lightGrey
                  : position.uPnlAtBidAsk > 0
                    ? colors.green
                    : colors.red
              }
            >
              {ApplyRounding(position.uPnlAtBidAsk, 2)}
            </Body4>
          </td>
          <td>
            <Body4
              fontWeight={600}
              color={
                position.realizedPnl === 0
                  ? colors.lightGrey
                  : position.realizedPnl > 0
                    ? colors.green
                    : colors.red
              }
            >
              {ApplyRounding(position.realizedPnl, 2)}
            </Body4>
          </td>
          <td>
            <Body4
              fontWeight={600}
              color={
                percentPnl === 0
                  ? colors.lightGrey
                  : percentPnl > 0
                    ? colors.green
                    : colors.red
              }
            >
              {percentPnl + '%'}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {estDateStringToTimeAndDateEST(position.date_acquired)}
            </Body4>
          </td>
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {ApplyRounding(position.cost_basis, 2)}
            </Body4>
          </td>
          {/* <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {position.accountId}
            </Body4>
          </td> */}
          <td>
            <Body4 fontWeight={600} color={colors.lightGrey}>
              {position.brokerage === 'BACKTEST' ? 'SIM' : position.brokerage}
            </Body4>
          </td>
      </tr>
    </>
  );
});

OpenPositionRow.propTypes = {
  department: PropTypes.string,
  odd: PropTypes.number,
  positionId: PropTypes.string,
};
